import { IconButton } from "@hortis/ui/button";
import { ButtonGroup } from "@hortis/ui/button/button-group";
import { useMediaQuery } from "@hortis/ui/hooks/media-query";
import { Transform, Trash3 } from "@hortis/ui/icons";
import { Tooltip, TooltipContent, TooltipTrigger } from "@hortis/ui/tooltip";

import { type MutableRefObject, useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

export const LocationDrawingButtons = ({
  drawRef,
}: {
  drawRef: MutableRefObject<MapboxDraw | undefined>;
}) => {
  const isMd = useMediaQuery("md");

  const [isDrawMode, setIsDrawMode] = useState(false);
  const currentMode = drawRef.current?.getMode();

  useEffect(() => {
    if (currentMode === "draw_polygon") {
      setIsDrawMode(true);
    } else {
      setIsDrawMode(false);
    }
  }, [currentMode]);

  return (
    <ButtonGroup
      direction="column"
      className="shadow-mg pointer-events-auto border-none"
    >
      <Tooltip>
        <TooltipTrigger asChild>
          <IconButton
            ariaLabel="Draw polygon"
            variant="tertiaryGray"
            onClick={() => {
              if (drawRef.current) {
                drawRef.current.changeMode("draw_polygon");
              }
              setIsDrawMode(true);
            }}
            size={isMd ? "md" : "sm"}
            icon={Transform}
            iconProps={{
              className: "stroke-grey-700! !hover:stroke-grey-800",
            }}
            className={twMerge("rounded-b-none", isDrawMode && "bg-grey-100!")}
          />
        </TooltipTrigger>
        <TooltipContent side="right">Draw polygon</TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <IconButton
            ariaLabel="Delete"
            variant="tertiaryGray"
            onClick={() => {
              if (drawRef.current) {
                const selectedFeatures = drawRef.current.getSelected();
                drawRef.current.delete(
                  selectedFeatures.features
                    .map((f) => f.id)
                    .filter((id): id is string => typeof id === "string"),
                );
              }
            }}
            size={isMd ? "md" : "sm"}
            icon={Trash3}
            iconProps={{
              className: "stroke-grey-700! !hover:stroke-grey-800",
            }}
            className="rounded-t-none"
          />
        </TooltipTrigger>
        <TooltipContent side="right">Delete</TooltipContent>
      </Tooltip>
    </ButtonGroup>
  );
};
